import { useState, useEffect } from 'react';

export const useMaintenanceMode = () => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check environment variable immediately
    const envMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
    
    // console.log('Environment variable:', process.env.REACT_APP_MAINTENANCE_MODE);
    // console.log('Maintenance mode:', envMaintenanceMode);
    
    setIsMaintenanceMode(envMaintenanceMode);
    setIsLoading(false); // Remove the setTimeout delay
  }, []);

  return { 
    isMaintenanceMode, 
    isLoading
  };
};